import React from 'react'
import { Availabilities, SelectedSlot } from '@customTypes/Availabilities'
import EmptyPeriodMsg from '../EmptyPeriodMsg'
import { Slots } from '../Slots/Slots'
import { SlotsUseStylesProps } from '../Slots/Slots.styles'
import { useAppointmentCalendar } from '@context/AppointmentCalendarContext/AppointmentCalendarContext'

interface ClinicSlotsProps extends SlotsUseStylesProps {
  clinicId: string
  currentPeriod: Availabilities[]
  selectedSlot: SelectedSlot
  isExpandable: boolean
  activeSlotRef: React.MutableRefObject<HTMLDivElement | null>
}

export const ClinicSlots = ({ clinicId, currentPeriod, variant, isExpandable, activeSlotRef }: ClinicSlotsProps) => {
  const { isTransitioning } = useAppointmentCalendar()
  const isWeekEmpty = !(currentPeriod || []).some((day) => day.availabilities.length)

  return (
    <>
      {isWeekEmpty && !isTransitioning ? (
        <EmptyPeriodMsg clinicId={clinicId} />
      ) : (
        <Slots
          activeSlotRef={activeSlotRef}
          clinicId={clinicId}
          currentWeek={currentPeriod}
          variant={variant}
          isExpandable={isExpandable}
        />
      )}
    </>
  )
}
